import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Form,
  Row,
  Tab,
  Nav,
} from "react-bootstrap";
import {
  getConfigure,
  getFieldData,
  getFinanceById,
  postConfigure,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/extra/loading";
import { useParams } from "react-router-dom";
import PersonalInfo from "./configureComponent/personalInfo";
import EmploymentInfo from "./configureComponent/EmploymentInfo";
import OtherFinancialInfo from "./configureComponent/OtherFinancialInfo";
import PersonalAssets from "./configureComponent/PersonalAssets";
import RealPropertyOwned from "./configureComponent/RealPropertyOwned";
import Vehicles from "./configureComponent/Vehicles";
import IncomeExpenseStatement from "./configureComponent/IncomeExpenseStatement";
import Assets from "./configureComponent/Assets";
import { StyleSheet } from "@react-pdf/renderer";
import { toast } from "react-toastify";
import LeagalInfo from "./configureComponent/Legal";
import BankruptcyInfo from "./configureComponent/Bankruptcy";

const ViewFinanceFormIndex = () => {
  const { editId } = useParams();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("personalInfo");
  const [personalInfoField, setPersonalInfoField] = useState([]);
  const [employmentInfoField, setEmploymentInfoField] = useState([]);
  const [otherFinanceInfoField, setOtherFinanceInfoField] = useState([]);
  const [personalAssetField, setPersonalAssetField] = useState([]);
  const [vehiclesField, setVehiclesField] = useState([]);
  const [realPropertyField, setRealPropertyField] = useState([]);
  const [assetsField, setAssetsField] = useState([]);
  const [incomeField, setIncomeField] = useState([]);
  const [legalField, setLegalField] = useState([]);
  const [bankruptcyField, setBankruptcyField] = useState([]);

  const [personalInfo, setPersonalInfo] = useState({
    full_name_visible: true,
    marital_status_visible: true,
    address_visible: true,
    home_phone_visible: true,
    cell_phone_visible: true,
    work_phone_visible: true,
    email_visible: true,
    fax_visible: true,
    social_security_no_visible: true,
    date_of_birth_visible: true,
    dependents_name_visible: true,
    dependents_age_visible: true,
    dependents_relationship_visible: true,

    full_name_required: true,
    marital_status_required: true,
    address_required: true,
    home_phone_required: true,
    cell_phone_required: true,
    work_phone_required: true,
    email_required: true,
    fax_required: true,
    social_security_no_required: true,
    date_of_birth_required: true,
    dependents_name_required: true,
    dependents_age_required: true,
    dependents_relationship_required: true,
  });

  const [legalInfo, setLegalInfo] = useState({
    full_name_visible: true,
    address_visible: true,
    cell_phone_visible: true,
    email_visible: true,

    full_name_required: true,
    address_required: true,
    cell_phone_required: true,
    email_required: true,
  });

  const [bankruptcyInfo, setBankruptcyInfo] = useState({
    bank_name_visible: true,
    account_number_visible: true,
    amount_visible: true,
    cell_phone_visible: true,
    email_visible: true,
    date_of_birth_visible: true,

    bank_name_required: true,
    account_number_required: true,
    amount_required: true,
    cell_phone_required: true,
    email_required: true,
    date_of_birth_required: true,
  });

  const [employmentInfo, setEmploymentInfo] = useState({
    employer_visible: true,
    length_of_job_visible: true,
    employer_address_visible: true,
    occupation_visible: true,
    pay_period_visible: true,

    employer_required: true,
    length_of_job_required: true,
    employer_address_required: true,
    occupation_required: true,
    pay_period_required: true,

    spouse_employer_visible: true,
    spouse_length_of_job_visible: true,
    spouse_employer_address_visible: true,
    spouse_occupation_visible: true,
    spouse_pay_period_visible: true,

    spouse_employer_required: true,
    spouse_length_of_job_required: true,
    spouse_employer_address_required: true,
    spouse_occupation_required: true,
    spouse_pay_period_required: true,
  });

  const [otherFinanceInfo, setOtherFinanceInfo] = useState({
    are_you_currently_a_party_to_law_suit_visible: true,
    plaintiff_defendent_visible: true,
    location_of_filing_visible: true,
    case_no_visible: true,
    subject_of_suit_visible: true,
    have_you_ever_filed_for_bankcrupty_protection_visible: true,
    date_of_filing_visible: true,
    date_of_discharge_visible: true,
    petition_no_visible: true,
    location_visible: true,
    increase_decrease_in_income_visible: true,
    beneficiary_to_any_trust_estate_life_insurance_visible: true,

    are_you_currently_a_party_to_law_suit_required: true,
    plaintiff_defendent_required: true,
    location_of_filing_required: true,
    case_no_required: true,
    subject_of_suit_required: true,
    have_you_ever_filed_for_bankcrupty_protection_required: true,
    date_of_filing_required: true,
    date_of_discharge_required: true,
    petition_no_required: true,
    location_required: true,
    increase_decrease_in_income_required: true,
    beneficiary_to_any_trust_estate_life_insurance_required: true,
  });

  const [personalAssets, setPersonalAssets] = useState({
    cash_on_hand_visible: true,
    cash_on_hand_required: true,

    personal_fullname_visible: true,
    personal_address_of_bank_visible: true,
    personal_account_type_visible: true,
    personal_account_number_visible: true,
    personal_account_balance_visible: true,

    personal_fullname_required: true,
    personal_address_of_bank_required: true,
    personal_account_type_required: true,
    personal_account_number_required: true,
    personal_account_balance_required: true,

    additional_fullname_visible: true,
    additional_address_of_bank_visible: true,
    additional_account_type_visible: true,
    additional_account_number_visible: true,
    additional_account_balance_visible: true,

    additional_fullname_required: true,
    additional_address_of_bank_required: true,
    additional_account_type_required: true,
    additional_account_number_required: true,
    additional_account_balance_required: true,

    investment_type_visible: true,
    investment_fullname_visible: true,
    investment_address_of_institution_visible: true,
    investment_account_number_visible: true,
    investment_account_balance_visible: true,

    investment_type_required: true,
    investment_fullname_required: true,
    investment_address_of_institution_required: true,
    investment_account_number_required: true,
    investment_account_balance_required: true,

    whole_life_insurance_visible: true,

    whole_life_insurance_required: true,

    credit_fullname_visible: true,
    credit_address_of_bank_visible: true,
    credit_account_type_visible: true,
    credit_account_number_visible: true,
    credit_account_balance_visible: true,

    credit_fullname_required: true,
    credit_address_of_bank_required: true,
    credit_account_type_required: true,
    credit_account_number_required: true,
    credit_account_balance_required: true,
  });

  const [realPropertyOwned, setRealPropertyOwned] = useState({
    property_description_visible: true,
    location_visible: true,
    current_fair_market_value_visible: true,
    loan_balance_visible: true,
    amount_of_monthly_payment_visible: true,
    amount_of_your_equity_visible: true,
    name_of_lender_visible: true,
    address_visible: true,
    account_no_visible: true,

    property_description_required: true,
    location_required: true,
    current_fair_market_value_required: true,
    loan_balance_required: true,
    amount_of_monthly_payment_required: true,
    amount_of_your_equity_required: true,
    name_of_lender_required: true,
    address_required: true,
    account_no_required: true,
  });

  const [vehicles, setVehicles] = useState({
    year_visible: true,
    make_visible: true,
    model_visible: true,
    mileage_visible: true,
    purchase_lease_date_visible: true,
    cutrrent_market_value_visible: true,
    amount_owned_visible: true,
    monthly_payment_visible: true,
    name_visible: true,
    address_visible: true,
    phone_of_lender_lessor_visible: true,

    year_required: true,
    make_required: true,
    model_required: true,
    mileage_required: true,
    purchase_lease_date_required: true,
    cutrrent_market_value_required: true,
    amount_owned_required: true,
    monthly_payment_required: true,
    name_required: true,
    address_required: true,
    phone_of_lender_lessor_required: true,

    another_year_visible: true,
    another_make_visible: true,
    another_model_visible: true,
    another_mileage_visible: true,
    another_purchase_lease_date_visible: true,
    another_cutrrent_market_value_visible: true,
    another_amount_owned_visible: true,
    another_monthly_payment_visible: true,
    another_name_visible: true,
    another_address_visible: true,
    another_phone_of_lender_lessor_visible: true,

    another_year_required: true,
    another_make_required: true,
    another_model_required: true,
    another_mileage_required: true,
    another_purchase_lease_date_required: true,
    another_cutrrent_market_value_required: true,
    another_amount_owned_required: true,
    another_monthly_payment_required: true,
    another_name_required: true,
    another_address_required: true,
    another_phone_of_lender_lessor_required: true,
  });

  const [assets, setAssets] = useState({
    furniture_visible: true,
    personal_visible: true,
    artwork_visible: true,
    jewellery_visible: true,
    collection_visible: true,
    guns_visible: true,
    coins_visible: true,
    antiques_visible: true,

    furniture_required: true,
    personal_required: true,
    artwork_required: true,
    jewellery_required: true,
    collection_required: true,
    guns_required: true,
    coins_required: true,
    antiques_required: true,
  });

  const [incomeExpenseState, setIncomeExpenseState] = useState({
    gross_visible: true,
    rent_visible: true,
    other_visible: true,
    child_visible: true,
    soc_visible: true,
    pension_visible: true,
    misc_visible: true,

    gross_required: true,
    rent_required: true,
    other_required: true,
    child_required: true,
    soc_required: true,
    pension_required: true,
    misc_required: true,

    primary_home_mortgage_visible: true,
    primary_home_tax_ins_visible: true,
    any_other_mortgage_visible: true,
    any_other_property_tax_ins_visible: true,
    credit_card_payments_total_visible: true,
    any_other_revolving_debt_visible: true,
    installment_loan_payments_visible: true,
    dependent_child_care_visible: true,

    primary_home_mortgage_required: true,
    primary_home_tax_ins_required: true,
    any_other_mortgage_required: true,
    any_other_property_tax_ins_required: true,
    credit_card_payments_total_required: true,
    any_other_revolving_debt_required: true,
    installment_loan_payments_required: true,
    dependent_child_care_required: true,

    personal_loans_visible: true,
    income_tax_from_paycheck_visible: true,
    fourZeroOneKLoans_visible: true,
    child_support_visible: true,
    alimony_visible: true,
    irs_liens_visible: true,
    tuition_visible: true,

    personal_loans_required: true,
    income_tax_from_paycheck_required: true,
    fourZeroOneKLoans_required: true,
    child_support_required: true,
    alimony_required: true,
    irs_liens_required: true,
    tuition_required: true,

    student_loans_visible: true,
    gas_visible: true,
    electric_visible: true,
    water_visible: true,
    trash_sewer_visible: true,
    telephone_visible: true,
    cell_phone_visible: true,
    internet_visible: true,
    cable_satellite_visible: true,
    vehicle_insurance_visible: true,
    maintenance_visible: true,
    food_visible: true,
    transportation_visible: true,
    gardening_landscaping_visible: true,
    housecleaning_visible: true,
    other_visible: true,

    student_loans_required: true,
    gas_required: true,
    electric_required: true,
    water_required: true,
    trash_sewer_required: true,
    telephone_required: true,
    cell_phone_required: true,
    internet_required: true,
    cable_satellite_required: true,
    vehicle_insurance_required: true,
    maintenance_required: true,
    food_required: true,
    transportation_required: true,
    gardening_landscaping_required: true,
    housecleaning_required: true,
    other_required: true,

    medical_visible: true,
    dental_visible: true,
    life_visible: true,
    vision_visible: true,
    disability_visible: true,
    surrender_visible: true,

    medical_required: true,
    dental_required: true,
    life_required: true,
    vision_required: true,
    disability_required: true,
    surrender_required: true,
  });

  useEffect(() => {
    dispatch(
      getConfigure({ option_id: "1", option_key: "AtsFinancialQuestionnaire" })
    );
    dispatch(getFieldData());
  }, []);

  const allData = useSelector(
    (s) => s?.Signatures?.getConfigure?.data?.option_value
  );

  const FieldData = useSelector(
    (s) => s?.Signatures?.getFieldData?.field_data?.option_value
  );

  useEffect(() => {
    if (FieldData) {
      setPersonalInfoField(FieldData?.personal_information_fields);
      setEmploymentInfoField(FieldData?.employment_information_fields);
      setOtherFinanceInfoField(FieldData?.other_finanical_information_fields);
      setPersonalAssetField(FieldData?.personal_assets_fields);
      setRealPropertyField(FieldData?.real_property_owned_fields);
      setVehiclesField(FieldData?.vehicles_fields);
      setAssetsField(FieldData?.assets_fields);
      setIncomeField(FieldData?.income_fields);
      setLegalField(FieldData?.legal_fields || []);
      setBankruptcyField(FieldData?.bankruptcy_fields || []);
    }
  }, [FieldData]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleExtraChange = (e, type) => {
    if (type === "personal_information") {
      setPersonalInfoField(e);
    } else if (type === "employment_information") {
      setEmploymentInfoField(e);
    } else if (type === "other_financial_information") {
      setOtherFinanceInfoField(e);
    } else if (type === "real_property_owned") {
      setRealPropertyField(e);
    } else if (type === "personal_assets") {
      setPersonalAssetField(e);
    } else if (type === "vehicles") {
      setVehiclesField(e);
    } else if (type === "assets") {
      setAssetsField(e);
    } else if (type === "income") {
      setIncomeField(e);
    } else if (type === "legal") {
      setLegalField(e);
    } else if (type === "bankruptcy") {
      setBankruptcyField(e);
    }
  };

  useEffect(() => {
    if (allData) {
      setPersonalInfo(allData?.personal_information);
      setEmploymentInfo(allData?.employment_information);
      setOtherFinanceInfo(allData?.other_finanical_information);
      setPersonalAssets(allData?.personal_assets);
      setRealPropertyOwned(allData?.real_property_owned);
      setVehicles(allData?.vehicles);
      setAssets(allData?.assets);
      setIncomeExpenseState(allData?.income);
      setLegalInfo(allData?.legal || legalInfo);
      setBankruptcyInfo(allData?.bankruptcy || bankruptcyInfo);
    }
  }, [allData]);

  useEffect(() => {
    let body = {
      user_id: editId,
      personal_information: personalInfo,
      legal_fields: legalInfo,
      bankruptcy_field: bankruptcyInfo,
      employment_information: employmentInfo,
      other_finanical_information: otherFinanceInfo,
      personal_assets: personalAssets,
      real_property_owned: realPropertyOwned,
      vehicles: vehicles,
      assets: assets,
      income: incomeExpenseState,
    };
    dispatch(
      postConfigure({
        option_id: "1",
        option_key: "AtsFinancialQuestionnaire",
        option_value: body,
      })
    );
  }, [
    personalInfo,
    employmentInfo,
    otherFinanceInfo,
    personalAssets,
    realPropertyOwned,
    vehicles,
    assets,
    incomeExpenseState,
    legalInfo,
    bankruptcyInfo,
  ]);

  const handleSaveField = () => {
    const callBack = (res) => {
      if (res.data) {
        toast.success("Updated Successfully!");
      }
    };
    let body = {
      personal_information_fields: personalInfoField,
      employment_information_fields: employmentInfoField,
      other_finanical_information_fields: otherFinanceInfoField,
      personal_assets_fields: personalAssetField,
      real_property_owned_fields: realPropertyField,
      vehicles_fields: vehiclesField,
      assets_fields: assetsField,
      income_fields: incomeField,
      legal_fields: legalField,
      bankruptcy_field: bankruptcyField,
    };
    dispatch(
      postConfigure(
        {
          option_id: "2",
          option_key: "AFQAdditionalFields",
          option_value: body,
        },
        callBack
      )
    );
  };

  return (
    <>
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item>Financial Configuration</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="12" className="my-2">
              <Tab.Container id="left-tabs-example">
                <div className="">
                  <Nav
                    variant="pills"
                    className="bg-white mb-3 commonTabs commonfinanceTabs viewprofile"
                  >
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "personalInfo" && "active"
                        }`}
                        onClick={() => handleTabChange("personalInfo")}
                      >
                        Personal Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "empInfo" && "active"
                        }`}
                        onClick={() => handleTabChange("empInfo")}
                      >
                        Employment Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "otherFinancialInfo" && "active"
                        }`}
                        onClick={() => handleTabChange("otherFinancialInfo")}
                      >
                        Other Financial Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "personalAssets" && "active"
                        }`}
                        onClick={() => handleTabChange("personalAssets")}
                      >
                        Personal Assets
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "realPropertyOwned" && "active"
                        }`}
                        onClick={() => handleTabChange("realPropertyOwned")}
                      >
                        Real Property Owned
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "vehicles" && "active"
                        }`}
                        onClick={() => handleTabChange("vehicles")}
                      >
                        Vehicles
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "assets" && "active"
                        }`}
                        onClick={() => handleTabChange("assets")}
                      >
                        Assets
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "incomeExpenseStatement" && "active"
                        }`}
                        onClick={() =>
                          handleTabChange("incomeExpenseStatement")
                        }
                      >
                        Income and Expense Statement
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "legal" && "active"
                        }`}
                        onClick={() => handleTabChange("legal")}
                      >
                        Legal
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        className={`bg-transparent border-0 py-3 position-relative px-3 ${
                          activeTab == "bankruptcy" && "active"
                        }`}
                        onClick={() => handleTabChange("bankruptcy")}
                      >
                        Bankruptcy
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <div className="bg-white px-4 py-3 card-box">
                  <Tab.Content>
                    <Tab.Pane
                      className={activeTab == "legal" ? "active show" : ""}
                    >
                      <LeagalInfo
                        state={legalInfo}
                        setState={setLegalInfo}
                        extraField={legalField}
                        handleExtraChange={handleExtraChange}
                        handleSaveField={handleSaveField}
                        activeTab={activeTab}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={activeTab == "bankruptcy" ? "active show" : ""}
                    >
                      <BankruptcyInfo
                        state={bankruptcyInfo}
                        setState={setBankruptcyInfo}
                        extraField={bankruptcyField}
                        handleExtraChange={handleExtraChange}
                        handleSaveField={handleSaveField}
                        activeTab={activeTab}
                      />
                    </Tab.Pane>

                    <Tab.Pane
                      className={
                        activeTab == "personalInfo" ? "active show" : ""
                      }
                    >
                      <PersonalInfo
                        state={personalInfo}
                        setState={setPersonalInfo}
                        handleExtraChange={handleExtraChange}
                        extraField={personalInfoField}
                        handleSaveField={handleSaveField}
                        activeTab={activeTab}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={activeTab == "empInfo" ? "active show" : ""}
                    >
                      <EmploymentInfo
                        state={employmentInfo}
                        setState={setEmploymentInfo}
                        handleExtraChange={handleExtraChange}
                        extraField={employmentInfoField}
                        activeTab={activeTab}
                        handleSaveField={handleSaveField}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={
                        activeTab == "otherFinancialInfo" ? "active show" : ""
                      }
                    >
                      <OtherFinancialInfo
                        state={otherFinanceInfo}
                        setState={setOtherFinanceInfo}
                        handleExtraChange={handleExtraChange}
                        extraField={otherFinanceInfoField}
                        activeTab={activeTab}
                        handleSaveField={handleSaveField}
                      />{" "}
                    </Tab.Pane>
                    <Tab.Pane
                      className={
                        activeTab == "personalAssets" ? "active show" : ""
                      }
                    >
                      <PersonalAssets
                        state={personalAssets}
                        setState={setPersonalAssets}
                        handleExtraChange={handleExtraChange}
                        extraField={personalAssetField}
                        activeTab={activeTab}
                        handleSaveField={handleSaveField}
                      />{" "}
                    </Tab.Pane>
                    <Tab.Pane
                      className={
                        activeTab == "realPropertyOwned" ? "active show" : ""
                      }
                    >
                      <RealPropertyOwned
                        state={realPropertyOwned}
                        setState={setRealPropertyOwned}
                        handleExtraChange={handleExtraChange}
                        extraField={realPropertyField}
                        activeTab={activeTab}
                        handleSaveField={handleSaveField}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={activeTab == "vehicles" ? "active show" : ""}
                    >
                      <Vehicles
                        state={vehicles}
                        setState={setVehicles}
                        handleExtraChange={handleExtraChange}
                        extraField={vehiclesField}
                        activeTab={activeTab}
                        handleSaveField={handleSaveField}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={
                        activeTab == "incomeExpenseStatement"
                          ? "active show"
                          : ""
                      }
                    >
                      <IncomeExpenseStatement
                        state={incomeExpenseState}
                        setState={setIncomeExpenseState}
                        handleExtraChange={handleExtraChange}
                        extraField={incomeField}
                        activeTab={activeTab}
                        handleSaveField={handleSaveField}
                      />
                    </Tab.Pane>
                    <Tab.Pane
                      className={activeTab == "assets" ? "active show" : ""}
                    >
                      <Assets
                        state={assets}
                        setState={setAssets}
                        handleExtraChange={handleExtraChange}
                        extraField={assetsField}
                        activeTab={activeTab}
                        handleSaveField={handleSaveField}
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default ViewFinanceFormIndex;
